export default __webpack_public_path__ + "static/media/loadingScreenImg.c2065ff3.png";